import axios from 'axios'
import api, { getResponseError } from '../../services/api'
import { TOrderRefundClaim } from '../types/OrderRefundClaim'
import { IErrorResponse } from '../types/ErrorResponse'

// code 404/400/403 preservado para o chamador decidir se recarrega o estado
const toError = (error: unknown): IErrorResponse => {
  const status = axios.isAxiosError(error) ? error.response?.status : undefined
  return { code: status ?? 2, error: getResponseError(error) }
}

const get = async ({
  orderId,
}: {
  orderId: string
}): Promise<TOrderRefundClaim | IErrorResponse> => {
  try {
    const { data } = await api.get<TOrderRefundClaim>(
      `/OrderRefundClaim/${orderId}`
    )
    return data ?? { code: 1, error: 'Erro inesperado do servidor' }
  } catch (error) {
    return toError(error)
  }
}

const sendCancelLink = async ({
  orderId,
}: {
  orderId: string
}): Promise<{ link: string } | IErrorResponse> => {
  try {
    const { data } = await api.post<{ link: string }>(
      `/OrderRefundClaim/${orderId}/send-cancel-link`
    )
    return data ?? { code: 1, error: 'Erro inesperado do servidor' }
  } catch (error) {
    return toError(error)
  }
}

const cancel = async ({
  orderId,
}: {
  orderId: string
}): Promise<IErrorResponse | undefined> => {
  try {
    await api.post(`/OrderRefundClaim/${orderId}/cancel`)
    return undefined
  } catch (error) {
    return toError(error)
  }
}

const OrderRefundClaimController = { get, sendCancelLink, cancel }

export default OrderRefundClaimController
